function getYoutubeId(link) {
  const regexp = /youtu(?:.*\/v\/|.*v=|\.be\/)([A-Za-z0-9_-]{11})/;
  const match = link?.match(regexp);

  if (!match) {
    throw new Error(`Invalid YouTube link: ${link}`);
  }

  return match[1];
}

module.exports = getYoutubeId;
